export const FirebaseConfig = {
	"projectId": "laderides",
	"appId": "1:7024661099:web:831bfc15fd8c14fcd2572e",
	"databaseURL": "https://laderides-default-rtdb.firebaseio.com",
	"storageBucket": "laderides.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCZfxwWTS6PBkRJiIOI-HRIZ8KrWTOijuc",
	"authDomain": "laderides.firebaseapp.com",
	"messagingSenderId": "7024661099",
	"measurementId": "G-Y06YEKN28B"
};